import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material";

@Component({
  selector: "bil-bil-documet-required-modal",
  templateUrl: "./bil-documet-required-modal.component.html",
  styleUrls: ["./bil-documet-required-modal.component.sass"]
})
export class BilDocumetRequiredModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<BilDocumetRequiredModalComponent>
  ) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }
}
